import { Box, Radio, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface VehicleSwitchStates {
    showValue: any
    setShowValue: any
    firstLabel?: string
    secondLabel?: string
}

const VehicleSwitch = ({ showValue, setShowValue, firstLabel, secondLabel }: VehicleSwitchStates) => {
    const { t } = useTranslation()
    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box display="flex" gap={1}>
                <Box display="flex" alignItems="center">
                    <Typography variant="labelMedium">
                        {firstLabel || t("global.internal_number_short", "Internal no")}
                    </Typography>
                    <Radio
                        checked={showValue}
                        onChange={(e) => setShowValue(true)}
                    />
                </Box>
                <Box display="flex" alignItems="center">
                    <Typography variant="labelMedium">
                        {secondLabel || t("global.reg_number_short", "Reg no")}
                    </Typography>
                    <Radio
                        checked={!showValue}
                        onChange={(e) => setShowValue(false)}
                    />
                </Box>
            </Box>
        </Box>
    )
}

export default VehicleSwitch